import Quill from 'quill';

// Custom Variable Blot - renders variables as styled placeholders
// This makes {{variable}} appear as [Variable Name] badges in the editor
const Inline = Quill.import('blots/inline');

class VariableBlot extends Inline {
  static create(value) {
    const node = super.create();
    node.setAttribute('data-variable', value);
    node.classList.add('ql-variable');
    
    // Display friendly name instead of variable name
    const friendlyName = value
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
    
    node.textContent = `[${friendlyName}]`;
    node.setAttribute('contenteditable', 'false'); // Make it non-editable
    node.setAttribute('spellcheck', 'false');
    return node;
  }

  static value(node) {
    return node.getAttribute('data-variable');
  }

  static formats(node) {
    return node.getAttribute('data-variable');
  }

  // Allow Quill to recognize existing variable spans in HTML
  static register() {
    if (this._registered) return;
    Quill.register(this);
    this._registered = true;
  }
}

VariableBlot.blotName = 'variable';
VariableBlot.tagName = 'span';
VariableBlot.className = 'ql-variable';

// Register the custom blot
VariableBlot.register();

export default VariableBlot;
